// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___N5HM","largestCol":"styles_largestCol__4mO-f","smallestCol":"styles_smallestCol__2zUkj"};